import { render, staticRenderFns } from "./customerMessage.vue?vue&type=template&id=a881625a&scoped=true&"
import script from "./customerMessage.vue?vue&type=script&lang=js&"
export * from "./customerMessage.vue?vue&type=script&lang=js&"
import style0 from "./customerMessage.vue?vue&type=style&index=0&id=a881625a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a881625a",
  null
  
)

export default component.exports